<template>
  <div
    class="flex align-center ag-row-with-bg"
    style="width: 100%; height: 100%; padding-left: 10px"
  >
    <div v-if="params.data.label">{{ params.data.label }}</div>
    <div
      class="flex"
      style="gap: 40px; width: 100%; font-weight: 500; padding-right: 10px"
    >
      <template v-if="params.data.billNumber">
        <div>Số hoá đơn: {{ params.data.billNumber }}</div>
        <div>Ngày hóa đơn: {{ params.data.billDate }}</div>
        <div>Mã đặt phòng: {{ params.data.bookingCode }}</div>
        <div>Nhân viên tạo: {{ params.data.createdBy }}</div>
        <div>Số phòng: {{ params.data.roomNum }}</div>
        <div>
          Tổng cộng: {{ Number(params.data.total).toLocaleString('en') }}
        </div>
      </template>
      <template v-else-if="params.data.totalBill != null">
        <div v-if="params.data.includeTaxFee">Bao gồm thuế, phí</div>
        <div>
          Tổng tiền giảm giá:
          {{ Number(params.data.totalDiscount).toLocaleString('en') }}
        </div>
        <div>
          Tổng tiền hóa đơn {{ params.data.billNum }}:
          {{ Number(params.data.totalBill).toLocaleString('en') }} (Phí dịch vụ:
          <span style="display: inline-block; margin-right: 4px"
            >{{ Number(params.data.serviceFee).toLocaleString('en') }}
          </span>
          Thuế GTGT:
          <span style="display: inline-block"
            >{{ Number(params.data.taxFee).toLocaleString('en') }} </span
          >)
        </div>
      </template>
      <template v-else-if="params.data.totalServiceBill">
        <div>
          Tổng {{ params.data.service }}: {{ params.data.totalServiceBill }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.ag-row-with-bg {
  background-color: $ag-selected-row-background-color;
}
</style>
